// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.header-container {\n    padding: 1rem 2rem;\n    margin-top: 7rem;\n    max-width: 100%;\n}\n\n.container-transcripts {\n    margin-top: 1rem;\n    padding: 1rem 3.5rem;\n}\n\n", ""]);
// Exports
module.exports = exports;
